<template>
    <common-modal width="extra-large" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="large">
            <div class="eprescribe-match-container">
                <div v-for="(element, index) in matchList" :key="index" class="eprescribe-match--item">
                    <practice-member-card
                        v-if="practiceType === PracticeTypeEnum.PHYSICIAN"
                        :physician="element"
                        :showCardAvailability="false"
                        :showNetworkInclusionStatus="false"
                        :isUserProfileLinkEnabled="false"
                    ></practice-member-card>
                    <ancillary-member-card
                        v-if="practiceType === PracticeTypeEnum.ANCILLARY"
                        :showCardAvailability="false"
                        :ancillary="element"
                    ></ancillary-member-card>
                </div>
            </div>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import PracticeMemberCard from 'components/page-elements/practice/PracticeMemberCard'
    import AncillaryMemberCard from 'components/page-elements/practice/AncillaryMemberCard'

    export default {
        components: { PracticeMemberCard, AncillaryMemberCard },

        props: {
            matchList: { type: Array, required: true },
            practiceType: { type: String, required: true },
        },

        data() {
            return {
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .eprescribe-match-container {
        display: flex;
        flex-wrap: wrap;
        max-height: 600px;
        overflow-y: scroll;

        .eprescribe-match--item {
            @include breakpoint(tablet) {
                width: calc((100% / 2) - 20px);
            }

            @include breakpoint(smartphone-large) {
                width: calc(100% - 20px);
            }

            margin: 10px 10px;
            width: calc((100% / 3) - 20px);

            .card {
                max-height: 375px;
                min-height: 375px;
            }
        }
    }
</style>
